module.exports = __webpack_public_path__ + "img/aw.47ea7038.svg";